<ion-app mode="md" [class.is-native]="isNative" [class.is-desktop]="isDesktop">
	<ion-split-pane contentId="main-content">
		<ion-menu contentId="main-content" type="reveal" [disabled]="menuDisabled">
			<ion-content>
				<ion-list id="inbox-list">
					<ion-list-header>{{brandName}}</ion-list-header>
					@if (profile())
					{
					<ion-menu-toggle auto-hide="false">
						<ion-item lines="none" detail routerLink="/account/connected">
							<ion-label>
								<h4>
									{{pharmacyPrefix}}
									{{profile()?.location?.name}}
								</h4>
								<p>{{profile()?.pharmacyLink?.userCaption}} - {{profile()?.pharmacyLink?.nhiNumber}}</p>
							</ion-label>
							<ion-badge *ngIf="(notifications()?.other ?? 0) > 0" color="danger">{{notifications()?.other}}</ion-badge>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/pharmacy', profile()?.pharmacyLink?.id, 'dashboard']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="home-outline"></ion-icon>
							<ion-label>Home</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/pharmacy', profile()?.pharmacyLink?.id, 'scripts']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="medkit-outline"></ion-icon>
							<ion-label>Prescriptions</ion-label>
							<ion-badge *ngIf="repeats() > 0" color="danger">{{repeats()}}</ion-badge>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false" *ngIf="shopEnabled">
						<ion-item routerDirection="root" [routerLink]="['/pharmacy', profile()?.pharmacyLink?.id, 'shop']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="cart-outline"></ion-icon>
							<ion-label>Shop</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/pharmacy', profile()?.pharmacyLink?.id, 'notifications']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="notifications-outline"></ion-icon>
							<ion-label>Messages</ion-label>
							<ion-badge *ngIf="(notifications()?.pharmacy ?? 0) > 0" color="danger">{{notifications()?.pharmacy}}</ion-badge>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/pharmacy', profile()?.pharmacyLink?.id, 'profile']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="person-outline"></ion-icon>
							<ion-label>Profile</ion-label>
						</ion-item>
					</ion-menu-toggle>
					}
					@else if (loggedIn())
					{
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/account/connected']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="storefront"></ion-icon>
							<ion-label>My pharmacies</ion-label>
						</ion-item>
					</ion-menu-toggle>
					}
					@else
					{
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/auth/welcome']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="home-outline"></ion-icon>
							<ion-label>Home</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/deals']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="cart-outline"></ion-icon>
							<ion-label>Shop</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/auth/login']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="log-in-outline"></ion-icon>
							<ion-label>Log in</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/auth/register']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="person-add-outline"></ion-icon>
							<ion-label>Register</ion-label>
						</ion-item>
					</ion-menu-toggle>
					}
					@if (vaccinationBookingUrl)
					{
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [href]="vaccinationBookingUrl" lines="none" detail="true" detailIcon="open-outline" (click)="bookVaccination($event)" [href]="vaccinationBookingUrl">
							<ion-icon aria-hidden="true" slot="start" name="calendar-outline"></ion-icon>
							<ion-label>Book a vaccination</ion-label>
						</ion-item>
					</ion-menu-toggle>
					}
				</ion-list>
				<ion-list id="labels-list">
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/about']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="information-circle-outline"></ion-icon>
							<ion-label>About</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" [routerLink]="['/locations']" lines="none" detail="false" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="location-outline"></ion-icon>
							<ion-label>Find a pharmacy</ion-label>
						</ion-item>
					</ion-menu-toggle>
					@if (loggedIn() || profile())
					{
					<ion-menu-toggle auto-hide="false">
						<ion-item lines="none" [routerLink]="['/account/settings']" routerLinkActive="selected">
							<ion-icon aria-hidden="true" slot="start" name="settings-outline"></ion-icon>
							<ion-label>Settings</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle auto-hide="false">
						<ion-item lines="none" [routerLink]="['/account/logout']">
							<ion-icon aria-hidden="true" slot="start" name="log-out-outline"></ion-icon>
							<ion-label>Log out</ion-label>
						</ion-item>
					</ion-menu-toggle>
					}
				</ion-list>

				<div class="footer-logo">
					<a href="/"><img src="assets/icon/logo.png" alt="Logo" style="max-width: 200px; width: 90%; height: auto; margin-bottom: 12px;" /></a>
					<p style="font-size: 10px; color: var(--ion-color-medium-tint);">© {{ currentYear }} Health Max<br /><a [href]="termsUrl" (click)="loadHref($event)">Terms of service</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a [href]="privacyPolicyUrl" (click)="loadHref($event)">Privacy</a></p>
				</div>
			</ion-content>
		</ion-menu>
		<ion-router-outlet id="main-content"></ion-router-outlet>
	</ion-split-pane>
</ion-app>